<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p style="font-size: 22px">
						{{vm.getName()}}
					</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close"
							(click)="vm.close()"
							*ngIf="vm.isSignupCompleted">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content" [ngClass]="{ 'u-no-pt': vm.isSignupCompleted }">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<form name="vm.form" class="c-form u-ost-xl">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<div class="c-form__group u-osb-lg">
								<label for="{{ 'rejectReason-' + vm.uid }}" class="c-form__label c-form__label--light">
									{{ 'Employees.Reject_Reason' | translate }}
								</label>
								<textarea rows="6" id="{{ 'rejectReason-' + vm.uid }}"
										  name="rejectReason" [(ngModel)]="vm.rejectReason"
										  class="c-form__input c-form__input--sm">
								</textarea>
							</div>
						</div>
					</div>
					<div class="c-panel u-no-p u-ost-sm u-osb-sm">
						<button id="rejectJoingRequestButton"
	                            type="button"
								(click)="vm.submit()"
								[disabled]="vm.processing || !vm.initialized"
								class="c-button c-button--s2 c-button--narrow c-button--fit u-no-wrap">
							{{ 'Employees.Button_Reject' | translate }}
						</button>
					</div>
				</form>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
